import { KNOLIA } from "@/knolia"
import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
    state: () => ({ 
        user: {}, 
        coreInfo: {}, 
        countValidations: {without_certification: 0, with_certification: 0, without_validator: 0, total: 0},
        countMessages: {
            rating_skills_message_count: 0, 
            validation_message_count: 0, 
            validation_with_certificate_message_count: 0, 
            validation_total_messages_count: 0,
        },
        lastFetched: null
    }),

    getters: {
        User: (state) => state.user,
        CountValidations: (state) => state.countValidations,
        CountMessages: (state) => state.countMessages,
        Core: (state) => state.coreInfo,
        LastFetched: (state) => state.lastFetched,
    },

    actions: {
        async GetUser() {
            // const res = await KNOLIA.CallBackEnd("post", "get-user", { params: { self: true } })
            const res = await KNOLIA.CallBackEnd("post", "router-check")

            if (!res.data.user) {
                return
            }

            res.data.user.search_users                       = Boolean(res.data.user.search_users)
            res.data.user.can_validate                       = Boolean(res.data.user.can_validate)
            res.data.user.accept_validate                    = Boolean(res.data.user.accept_validate)
            res.data.user.can_manage_subordinates_activities = Boolean(res.data.user.can_manage_subordinates_activities)
            res.data.user.can_check_skill_cards              = Boolean(res.data.user.can_check_skill_cards)

            this.lastFetched = new Date()
            this.user = res.data.user
            this.coreInfo = res.data.core
            this.countValidations = res.data.request_count
            this.countMessages = res.data.count_messages
        },

        resetUser() {
            this.user = {}
        },

        SetCountValidations(countValidations) {
            this.countValidations = countValidations ?? {without_certification: 0, with_certification: 0, without_validator: 0, total: 0}
        },

        SetCountMessages(countMessages) {
            this.countMessages = countMessages ?? {
                                                    rating_skills_message_count: 0, 
                                                    validation_message_count: 0, 
                                                    validation_with_certificate_message_count: 0, 
                                                    validation_total_count: 0,
                                                }
        },
    }
})
